import Vue from 'vue'
import Vuex from 'vuex'

import systemUsers from '@/stores/systemUsers'

import license from '@/stores/settings/license'
import switchTariff from '@/stores/settings/switchTariff'
import additional from '@/stores/settings/additional'
import promisedPayment from '@/stores/settings/promisedPayment'
import transferFunds from '@/stores/settings/transferFunds'
import registrySettings from '@/stores/settings/registrySettings'
import ISGattributes from '@/stores/settings/ISGattributes'
import companies from '@/stores/settings/companies'
import ipPools from '@/stores/settings/ipPools'
import firewalls from '@/stores/settings/firewalls'
import firewallRules from '@/stores/settings/firewallRules'
import NASlist from '@/stores/settings/NASlist'
import radiusAccounts from '@/stores/settings/radiusAccounts'
import ISGprofile from '@/stores/settings/ISGprofile'
import documentTemplates from '@/stores/settings/documentTemplates'
import profilesOfDocuments from '@/stores/settings/profilesOfDocuments'
import replacementsInDocument from '@/stores/settings/replacementsInDocument'
import emergencyCalls from '@/stores/settings/emergencyCalls'
import telephoneOperators from '@/stores/settings/telephoneOperators'
import telSupplierServiceReports from '@/stores/settings/telSupplierServiceReports'
import archiveDB from '@/stores/settings/archiveDB'
import netFlowProviders from '@/stores/settings/netFlowProviders'
import trafficCollectors from '@/stores/settings/trafficCollectors'
import paymentSystems from '@/stores/settings/paymentSystems'
import voluntarySuspension from '@/stores/settings/voluntarySuspension'
import userIndependentServicesConnect from '@/stores/settings/userIndependentServicesConnect'
import dynamicShaping from '@/stores/settings/dynamicShaping'
import rabbitMQ from '@/stores/settings/rabbitMQ'
import DHCPv6 from '@/stores/settings/DHCPv6'
import collectors from '@/stores/settings/collectors'
import captivePortal from '@/stores/settings/captivePortal'

import tariff from '@/stores/tariffing/tariff'
import service from '@/stores/tariffing/service'
import telZones from '@/stores/tariffing/telZones'
import telDirections from '@/stores/tariffing/telDirections'
import timeRange from '@/stores/tariffing/timeRange'
import trafficClasses from '@/stores/tariffing/trafficClasses'
import radiusAttr from '@/stores/tariffing/radiusAttr'
import accountingPeriod from '@/stores/tariffing/accountingPeriod'
import contractType from '@/stores/tariffing/contractType'
import oneTimeService from '@/stores/tariffing/oneTimeService'
import timeRanges from '@/stores/tariffing/timeRanges'
import coefficientScheme from '@/stores/tariffing/coefficientScheme'
import chargePolicies from '@/stores/tariffing/chargePolicies'

import groups from '@/stores/users/groups'
import irdeto from '@/stores/users/irdeto'
import systemUsersShortData from '@/stores/users/systemUsersShortData'
import systemsUsers from '@/stores/users/systemUsers'
import users from '@/stores/users/users'
import cardPools from '@/stores/users/cardPools'
import systemGroups from '@/stores/users/systemGroups'
import accounts from '@/stores/users/accounts'
import accessCards from '@/stores/users/accessCards'

import paymentMethods from '@/stores/referencebooks/paymentMethods'
import currencies from '@/stores/referencebooks/currencies'
import banks from '@/stores/referencebooks/banks'
import IPzones from '@/stores/referencebooks/IPzones'
import buildings from '@/stores/referencebooks/buildings'
import streets from '@/stores/referencebooks/streets'

import switchTypes from '@/stores/inventory/switchTypes'
import switches from '@/stores/inventory/switches'
import dhcpPools from '@/stores/inventory/dhcpPools'
import dhcpOptions from '@/stores/inventory/dhcpOptions'
import dhcpLeaseInventory from '@/stores/inventory/dhcpLease'

import blockings from '@/stores/reports/blockings'
import changeLog from '@/stores/reports/changeLog'
import sessions from '@/stores/reports/sessions'
import dhcpLease from '@/stores/reports/dhcpLease'
import payments from '@/stores/reports/payments'
import internalTransfer from '@/stores/reports/internalTransfer'
import expiringPayments from '@/stores/reports/expiringPayments'
import otherCharges from '@/stores/reports/otherCharges'
import documents from '@/stores/reports/documents'
import general from '@/stores/reports/general'
import services from '@/stores/reports/services'
import customChargesReport from '@/stores/reports/customChargesReport'
import traffic from '@/stores/reports/traffic'
import telephony from '@/stores/reports/telephony'
import telephonyDirections from '@/stores/reports/telephonyDirections'
import detailedTraffic from '@/stores/reports/detailedTraffic'
Vue.use(Vuex)

function moduleUnion (modules) {
  let result = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {}
  }
  for (let el of modules) {
    result.state = {...el.state, ...result.state}
    result.getters = {...el.getters, ...result.getters}
    result.mutations = {...el.mutations, ...result.mutations}
    result.actions = {...el.actions, ...result.actions}
  }
  return result
}

export const store = new Vuex.Store({
  state: null,
  getters: {
    API_LOGIN: state => {
      return '/login'
    },

    API_USERS: state => {
      return '/users/'
    },
    API_USERS_SEARCH: state => {
      return '/users/search'
    },
    API_USERS_ACCOUNTS: state => {
      return '/users/accounts'
    },
    API_USERS_ACCOUNTS_SEARCH: state => {
      return '/users/accounts/search'
    },
    API_USERS_ACCESS_CARD: state => {
      return '/users/access_card'
    },
    API_USERS_ACTIVATION_CODES: state => {
      return '/users/activation_codes'
    },
    API_USERS_FULL_INFO: state => {
      return '/users/full_info'
    },
    API_USERS_INVOICES: state => {
      return '/users/invoices'
    },
    API_USERS_DOCUMENTS: state => {
      return '/users/documents'
    },
    API_USERS_DOCUMENTS_DOWNLOAD: state => {
      return '/users/documents/download'
    },
    API_USERS_GROUPS: state => {
      return '/users/groups'
    },
    API_USERS_GROUP_INFO: state => {
      return '/users/group_info'
    },
    API_USERS_USER_FROM_GROUP: state => {
      return '/users/user_from_group'
    },
    API_USERS_IP_GROUPS: state => {
      return '/users/ip_groups'
    },
    API_USERS_TEL_NUMBERS: state => {
      return '/users/tel_numbers'
    },
    API_USERS_SYSTEM_GROUPS: state => {
      return '/users/system_groups'
    },
    API_USERS_CONTACTS: state => {
      return '/users/contacts'
    },
    API_USERS_CONTRACTS: state => {
      return '/users/contracts'
    },
    API_USERS_SERVICES_IN_TARIFF_LINK: state => {
      return '/users/services_in_tariff_link'
    },
    API_USERS_TARIFF_LINK: state => {
      return '/users/tariff_link'
    },
    API_USERS_TARIFFLINKS: state => {
      return '/users/tarifflinks'
    },
    API_USERS_TECH_PARAMS: state => {
      return '/users/tech_params'
    },
    API_USERS_CONTRACTS_UPLOAD: state => {
      return '/users/contracts/upload'
    },
    API_USERS_CARD_POOLS: state => {
      return '/users/card_pools'
    },
    API_USERS_CARD_POOL: state => {
      return '/users/card_pool'
    },
    API_USERS_BLOCK_CARD: state => {
      return '/users/block_card'
    },
    API_USERS_UNBLOCK_CARD: state => {
      return '/users/unblock_card'
    },
    API_USERS_SYSTEM_USERS: state => {
      return '/users/system_users'
    },
    API_USERS_CLEAR_EXPIRED_CARD: state => {
      return '/users/clear_expired_card'
    },
    API_USERS_CARD_POOL_OWNER: state => {
      return '/users/card_pool_owner'
    },
    API_USERS_CONTRACTS_DOWNLOAD: state => {
      return '/users/contracts/download'
    },
    API_USERS_SYSTEMUSERS_SHORT: state => {
      return '/users/systemusersshort'
    },
    API_USERS_SERVICE_LINKS: state => {
      return '/users/servicelinks'
    },
    API_USERS_SERVICELINKS_ONCE: state => {
      return '/users/servicelinks/once'
    },
    API_USERS_SERVICELINKS_PERIODIC: state => {
      return '/users/servicelinks/periodic'
    },
    API_USERS_SERVICELINKS_DIALUP: state => {
      return '/users/servicelinks/dialup'
    },
    API_USERS_SERVICELINKS_HOTSPOT: state => {
      return '/users/servicelinks/hotspot'
    },
    API_USERS_SERVICELINKS_TELEPHONY: state => {
      return '/users/servicelinks/telephony'
    },
    API_USERS_SERVICELINKS_IPTRAFFIC: state => {
      return '/users/servicelinks/iptraffic'
    },
    API_USERS_SERVICELINKS_IPTV: state => {
      return '/users/servicelinks/iptv'
    },
    API_USERS_SERVICELINKS_VOD: state => {
      return '/users/servicelinks/vod'
    },
    API_USERS_SERVICELINKS_PERIODIC_SLINK_STATS: state => {
      return '/users/servicelinks/periodic_slink_stats'
    },
    API_USERS_SERVICELINKS_COEFFICIENT_SCHEDULE: state => {
      return '/users/servicelinks/coefficient_schedule'
    },
    API_USERS_SERVICELINKS_ENABLE_TURBO_MODE: state => {
      return '/users/servicelinks/enable_turbo_mode'
    },

    API_TARIFFING_PAYMENTS: state => {
      return '/tariffing/payments'
    },
    API_TARIFFING_PROMISED_PAYMENTS: state => {
      return '/tariffing/promised_payments'
    },
    API_TARIFFING_TARIFFS: state => {
      return '/tariffing/tariffs'
    },
    API_TARIFFING_TARIFF: state => {
      return '/tariffing/tariff'
    },
    API_TARIFFING_SUPPLIER: state => {
      return '/tariffing/suppliers'
    },
    API_TARIFFING_CONTRACT_TYPE: state => {
      return '/tariffing/contract_type'
    },
    API_TARIFFING_CONTRACT_TYPES: state => {
      return '/tariffing/contract_types'
    },
    API_TARIFFING_SERVICES_ONCE: state => {
      return '/tariffing/services/once'
    },
    API_TARIFFING_SERVICES_PERIODIC: state => {
      return '/tariffing/services/periodic'
    },
    API_TARIFFING_SERVICES_IPTRAFFIC: state => {
      return '/tariffing/services/iptraffic'
    },
    API_TARIFFING_SERVICES_HOTSPOT: state => {
      return '/tariffing/services/hotspot'
    },
    API_TARIFFING_SERVICES_DIALUP: state => {
      return '/tariffing/services/dialup'
    },
    API_TARIFFING_SERVICES_TELEPHONY: state => {
      return '/tariffing/services/telephony'
    },
    API_TARIFFING_SERVICES_IPTV: state => {
      return '/tariffing/services/iptv'
    },
    API_TARIFFING_SERVICES_VOD: state => {
      return '/tariffing/services/vod'
    },
    API_TARIFFING_SERVICES: state => {
      return '/tariffing/services'
    },
    API_TARIFFING_SERVICES_SET_SUPPLIER_ID: state => {
      return '/tariffing/services/set_supplier_id'
    },
    API_TARIFFING_SERVICES_SET_CHRGE_POLICY: state => {
      return '/tariffing/services/set_charge_policy'
    },
    API_TARIFFING_SERVICES_SET_MULTI_LINKING: state => {
      return '/tariffing/services/set_multi_linking'
    },
    API_TARIFFING_SERVICES_LINKS_COUNT: state => {
      return '/tariffing/services/links_count'
    },
    API_TARIFFING_CHARGE_POLICE: state => {
      return '/tariffing/charge_polices'
    },
    API_TARIFFING_CHARGE_POLICY: state => {
      return '/tariffing/charge_policy'
    },
    API_TARIFFING_COEFFICIENT_SCHEME: state => {
      return '/tariffing/coefficient_scheme'
    },
    API_TARIFFING_TRAFFIC_CLASSES: state => {
      return '/tariffing/traffic_classes'
    },
    API_TARIFFING_TEL_ZONES: state => {
      return '/tariffing/tel_zones'
    },
    API_TARIFFING_GET_TEL_DIRECTIONS: state => {
      return '/tariffing/get_tel_directions'
    },
    API_TARIFFING_TEL_DIRECTION: state => {
      return '/tariffing/tel_direction'
    },
    API_TARIFFING_COEFFICIENT_SCHEDULE: state => {
      return '/tariffing/coefficient_schedule'
    },
    API_TARIFFING_ACCOUNTING_PERIODS: state => {
      return '/tariffing/accounting_periods'
    },
    API_TARIFFING_ACCOUNTING_PERIOD: state => {
      return '/tariffing/accounting_period'
    },
    API_TARIFFING_TIME_RANGE: state => {
      return '/tariffing/time_ranges'
    },
    API_TARIFFING_RADIUS_ATTRS: state => {
      return '/tariffing/radius_attrs'
    },
    API_TARIFFING_MEDIA_CONTENTS: state => {
      return '/tariffing/media_contents'
    },
    API_TARIFFING_MEDIA_GROUPS: state => {
      return '/tariffing/media_groups'
    },
    API_TARIFFING_TCLASSES: state => {
      return '/tariffing/tclasses'
    },
    API_TARIFFING_TRAFFIC_CLASS: state => {
      return '/tariffing/traffic_class'
    },
    API_TARIFFING_HOTSPOT_NETWORKS: state => {
      return '/tariffing/hotspot_networks'
    },

    API_SETTINGS_ADDITIONAL_PARAMS: state => {
      return '/settings/additionalparams'
    },
    API_SETTINGS_ADDITIONAL_IPPOOLS: state => {
      return '/settings/ippools'
    },
    API_SETTINGS_NETFLOW_PROVIDERS: state => {
      return '/settings/netflow_providers'
    },
    API_SETTINGS_CUSTOM_ISG_ATTRS: state => {
      return '/settings/custom_isg_attrs'
    },
    API_SETTINGS_COLLECTOS: state => {
      return '/settings/collectors'
    },
    API_SETTINGS_DOCUMENTS_PROFILES: state => {
      return '/settings/documents/profiles'
    },
    API_SETTINGS_DOCUMENTS_TEMPLATES: state => {
      return '/settings/documents/templates'
    },
    API_SETTINGS_ROUTERS: state => {
      return '/settings/routers'
    },
    API_SETTINGS_SHAPING: state => {
      return '/settings/shaping'
    },
    API_SETTINGS_TECH_PARAMS: state => {
      return '/settings/tech_params'
    },
    API_SETTINGS_TECH_PARAMS_SLINKS: state => {
      return '/settings/tech_params_slinks'
    },
    API_SETTINGS_PAYMENT_SYSTEMS: state => {
      return '/settings/payment_systems'
    },

    API_REFERENCE_BOOKS_BANKS: state => {
      return '/referencebooks/banks'
    },
    API_REFERENCE_BOOKS_IP_ZONES: state => {
      return '/referencebooks/ip_zones'
    },
    API_REFERENCE_BOOKS_HOUSES: state => {
      return '/referencebooks/houses'
    },
    API_TARIFFING_PAYMENTS_METHODS: state => {
      return '/referencebooks/paymentmethods'
    },
    API_REFERENCE_BOOKS_CURRENCIES: state => {
      return '/referencebooks/currencies'
    },
    API_INVENTORY_SWITCHES: state => {
      return '/inventory/switches'
    },
    API_INVENTORY_DHCP_POOLS: state => {
      return '/inventory/dhcp_pools'
    },
    API_INVENTORY_DHCP_LEASES: state => {
      return '/inventory/dhcp_leases'
    },
    API_INVENTORY_DHCP_LEASE: state => {
      return '/inventory/dhcp_lease'
    },
    API_INVENTORY_DHCP_POOL: state => {
      return '/inventory/dhcp_pool'
    },
    API_INVENTORY_EXPIRE_DHCP_LEASE: state => {
      return '/inventory/expire_dhcp_lease'
    },
    API_PERMISSIONS: state => {
      return '/permissions'
    },

    API_ROUTES: state => {
      return '/routes'
    }
  },
  mutations: null,
  actions: null,
  modules: {
    SystemUsers: systemUsers,
    Settings: moduleUnion([switchTariff, promisedPayment, transferFunds, registrySettings, netFlowProviders, trafficCollectors,
      profilesOfDocuments, replacementsInDocument, archiveDB, documentTemplates, emergencyCalls, ipPools, paymentSystems,
      companies, ISGattributes, voluntarySuspension, telephoneOperators, telSupplierServiceReports, firewalls, firewallRules,
      additional, NASlist, ISGprofile, userIndependentServicesConnect, radiusAccounts, dynamicShaping, userIndependentServicesConnect,
      rabbitMQ, license, DHCPv6, collectors, captivePortal]),
    Tariffing: moduleUnion([tariff, service, telZones, telDirections, timeRange, radiusAttr, accountingPeriod, oneTimeService, trafficClasses,
      contractType, timeRanges, coefficientScheme, chargePolicies]),
    Users: moduleUnion([groups, irdeto, systemUsersShortData, systemsUsers, users, cardPools, systemGroups, accounts, accessCards]),
    ReferenceBooks: moduleUnion([paymentMethods, currencies, banks, IPzones, buildings, streets]),
    Inventory: moduleUnion([switchTypes, switches, dhcpPools, dhcpOptions, dhcpLeaseInventory]),
    Reports: moduleUnion([blockings, changeLog, sessions, dhcpLease, payments, internalTransfer, expiringPayments, otherCharges,
      documents, general, services, customChargesReport, traffic, telephony, telephonyDirections, detailedTraffic])
  }
})



// WEBPACK FOOTER //
// ./src/store.js